// extracted by mini-css-extract-plugin
export default {"dropdown":"Dropdown-module__dropdown--FsC1L","wrapper":"Dropdown-module__wrapper--Xes_q"};